import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { globals } from '../Globals/Globals';

const ProtectedRoute = ({ children }) => {
  
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to="/login-page" />;
  }

  return children;
};

export default ProtectedRoute;  